import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from '@rd/core/components/footer/footer.component';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { BRAND_NAME } from '@rd/core/tokens/rd-lib.token';

@Component({
  selector: 'rd-anz-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzFooterComponent extends FooterComponent {
  @HostBinding('class.rd-anz-footer') componentClass = true;

  constructor(
    @Inject(BRAND_NAME) protected brandName: string,
    protected urlUtilService: UrlUtilsService,
    private router: Router,
  ) {
    super(brandName, urlUtilService);
  }

  get faqsUrl(): string {
    return '/faq';
  }

  get contactUsUrl(): string {
    return '/contact_us';
  }

  get tncsUrl(): string {
    return '/terms_of_use';
  }

  get privacyPolicyUrl(): string {
    return '/privacy_policy';
  }

  get websiteUrl(): string {
    return this.brandName === 'ANZ'
      ? 'https://www.anz.com.au/personal/'
      : 'https://www.anz.com.au/business/';
  }

  get whistleBlowerUrl(): string {
    return 'https://www.anz.com/shareholder/centre/about/corporate-governance/';
  }

  shouldHideFooter(): boolean {
    const ROUTE_URLS = [
      '/orders/past-redemptions',
      '/gift_card/listing',
      '/shopping-cart/home',
      'shopping-cart/delivery',
      'shopping-cart/payment',
      '/gift_card/listing',
      '/merchandise/all',
      '/merchandise/category',
    ];
    const hiddenRoute = !!ROUTE_URLS.find((url) =>
      this.router.url.startsWith(url),
    );

    return hiddenRoute;
  }
}
